import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnKE: CultureInfo = {
  name: 'en-KE',
  displayName: 'English (Kenya)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-KE',
  parent: CultureInfoEn
};
